import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private meta: Meta = inject(Meta);

  public normalizeContentfulTitle(title: string): string {
    return title.replace(new RegExp('#', 'g'), '').trim();
  }

  public updateDescriptionMetaTag(description: string): void {
    this.updateMetaTag('description', description);
  }

  private updateMetaTag(name: string, content: string): void {
    this.meta.updateTag({ name, content });
  }
}
